import { SVGProps } from "@/types/svg";
import Svg from "./Svg";
import Styles from "./NumberFireLogo.module.scss";

function NumberFireLogo({ width = "105", height = "24" }: SVGProps) {
  return (
    <Svg
      data-testid="poweredByNumberFire-svg"
      width={width}
      height={height}
      viewBox="0 0 105 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={Styles.icon}
    >
      <path
        d="M22.5249 17.1256V8.72564C22.5249 8.72564 23.0563 8.67421 23.4678 8.67421C24.4106 8.67421 24.822 9.39421 24.822 9.85706C24.9763 9.61706 25.8163 8.45135 27.222 8.45135C29.0906 8.45135 30.5478 10.0971 30.5478 12.4285V17.1256H28.1649V12.9085C28.1649 11.5028 27.6849 10.4056 26.2792 10.4056C25.3363 10.4056 24.9763 11.0228 24.9249 11.2628V17.1256H22.5249ZM90.0335 17.1256H87.6335V9.42849L88.662 9.39421C89.6049 9.39421 90.0335 10.0971 90.0335 10.5599V17.1256ZM78.702 10.7999C77.1935 10.5599 75.9592 11.1256 75.6849 11.9656V17.1256H73.302V8.72564C73.302 8.72564 73.7478 8.67421 74.142 8.67421C75.0849 8.67421 75.4963 9.39421 75.4963 9.85706C75.6506 9.61706 76.3535 8.58849 78.222 8.58849C78.3864 8.58128 78.5503 8.61055 78.702 8.67421V10.7999ZM96.5306 10.7999C95.022 10.5599 93.7878 11.1256 93.5306 11.9656V17.1256H91.1306V8.72564C91.1306 8.72564 91.5763 8.67421 91.9706 8.67421C92.9135 8.67421 93.342 9.39421 93.342 9.85706C93.4792 9.61706 94.182 8.58849 96.0506 8.58849C96.215 8.58128 96.3789 8.61055 96.5306 8.67421V10.7999ZM50.9135 8.45135C49.6278 8.45135 48.6335 9.34278 48.2563 9.73706C47.9709 9.33969 47.5952 9.01587 47.16 8.79232C46.7248 8.56877 46.2427 8.4519 45.7535 8.45135C44.3478 8.45135 43.5078 9.61706 43.3535 9.85706C43.3535 9.39421 42.942 8.67421 41.9992 8.67421C41.6049 8.67421 41.0563 8.72564 41.0563 8.72564V17.1256H43.4563V11.2628C43.5078 11.0228 43.8849 10.4056 44.8106 10.4056C46.2163 10.4056 46.6963 11.5028 46.6963 12.9085V17.1256H49.0792V12.4285C49.087 11.9113 49.0118 11.3962 48.8563 10.9028C49.0792 10.6456 49.4735 10.4056 50.2106 10.4056C51.6163 10.4056 52.0963 11.5028 52.0963 12.9085V17.1256H54.4792V12.4285C54.4792 10.0971 53.262 8.45135 50.9135 8.45135ZM39.702 8.67421V17.0742C39.702 17.0742 39.1706 17.1256 38.7592 17.1256C37.8163 17.1256 37.4049 16.6628 37.4049 15.9599C37.2678 16.1828 36.3763 17.3656 34.9706 17.3656C33.0849 17.3656 31.6792 15.7199 31.6792 13.3714V8.67421H34.0792V12.9085C34.0792 14.3142 34.4906 15.3942 35.8963 15.3942C36.8392 15.3942 37.2678 14.7771 37.302 14.5542V8.67421H39.702ZM55.662 4.97135L56.6392 4.91992C57.582 4.91992 58.0449 5.39992 58.0449 6.10278V9.39421C58.664 8.80107 59.4847 8.46422 60.342 8.45135C62.2278 8.45135 63.8735 10.1314 63.8735 12.9599C63.8735 15.2914 62.2792 17.3656 59.4163 17.3656C57.7706 17.3656 55.8849 16.8514 55.662 16.6628V4.97135ZM68.742 8.51992C72.1192 8.51992 72.222 11.4171 72.222 11.9656C72.2303 12.4861 72.1668 13.0053 72.0335 13.5085H67.062C67.062 14.7771 67.902 15.5314 69.3078 15.5314C69.7501 15.5123 70.1909 15.4665 70.6278 15.3942C70.8104 15.3605 70.9982 15.3684 71.1774 15.4174C71.3565 15.4664 71.5222 15.5551 71.6623 15.6771C71.8023 15.799 71.9131 15.9509 71.9862 16.1216C72.0594 16.2923 72.0931 16.4773 72.0849 16.6628C71.2278 17.1256 70.2506 17.3656 68.8449 17.3656C66.7363 17.3656 64.6106 15.9599 64.6106 12.9085C64.6106 10.3199 66.2563 8.51992 68.742 8.51992ZM100.885 8.51992C104.262 8.51992 104.365 11.4171 104.365 11.9656C104.373 12.4861 104.31 13.0053 104.176 13.5085H99.2049C99.2049 14.7771 100.045 15.5314 101.451 15.5314C101.893 15.5112 102.334 15.4654 102.771 15.3942C102.953 15.3605 103.141 15.3684 103.32 15.4174C103.499 15.4664 103.665 15.5551 103.805 15.6771C103.945 15.799 104.056 15.9509 104.129 16.1216C104.202 16.2923 104.236 16.4773 104.228 16.6628C103.371 17.1256 102.393 17.3656 100.988 17.3656C98.8792 17.3656 96.7535 15.9599 96.7535 12.9085C96.7535 10.3199 98.3992 8.51992 100.885 8.51992ZM79.782 17.1256V5.39992H86.5706V6.34278C86.5776 6.53086 86.5463 6.7184 86.4785 6.89401C86.4108 7.06961 86.3081 7.22961 86.1766 7.36429C86.0452 7.49897 85.8877 7.60552 85.7137 7.67746C85.5398 7.7494 85.3531 7.78523 85.1649 7.78278H82.1649V10.5599H85.6449V12.6685H82.1649V17.1256H79.782ZM87.4106 6.80564C87.4072 7.08776 87.4878 7.36452 87.642 7.60075C87.7963 7.83698 88.0173 8.02202 88.277 8.13234C88.5367 8.24267 88.8233 8.2733 89.1004 8.22035C89.3775 8.1674 89.6327 8.03326 89.8334 7.83497C90.0341 7.63668 90.1713 7.3832 90.2276 7.10673C90.2839 6.83027 90.2567 6.5433 90.1496 6.28231C90.0424 6.02132 89.8601 5.79808 89.6257 5.64096C89.3914 5.48384 89.1156 5.39994 88.8335 5.39992H87.4106V6.80564ZM59.6049 10.3542C58.7135 10.3542 58.1478 10.7999 58.0449 11.0228V15.3942C58.4052 15.5393 58.7881 15.6206 59.1763 15.6342C60.582 15.6342 61.4906 14.8285 61.4906 12.9599C61.4906 11.5371 60.822 10.3542 59.6049 10.3542ZM68.6563 10.0971C67.662 10.0971 67.062 11.0228 67.062 11.8799H70.0106C70.1135 11.0228 69.5478 10.0971 68.6563 10.0971ZM100.799 10.0971C99.8049 10.0971 99.2049 11.0228 99.2049 11.8799H102.153C102.256 11.0228 101.691 10.0971 100.799 10.0971Z"
        fill="#0A141E"
      />
      <path
        d="M2.12571 19.4571C0.774945 17.988 0.0174684 16.0699 0 14.0743C0 10.8 1.88571 7.50857 4.23428 6.56571C4.69714 7.97143 5.41714 9.87429 8.45143 9.85714C5.16 3.29143 10.3371 0 11.2629 0C11.2629 3.06857 13.2171 5.16 14.9829 7.40572L9.97714 16.3886L6.12 12.2743L2.12571 19.4571ZM10.3371 19.2343L6.48 15.12L3.39428 20.64C4.98003 21.8526 6.9181 22.5146 8.91428 22.5257C13.6114 22.5257 17.8286 18.7714 17.8286 14.0743C17.8286 12.0171 17.0914 10.3886 16.0971 8.91429L10.3371 19.2343Z"
        fill="url(#paint0_linear_4515_10212)"
      />
      <path
        d="M2.12571 19.4571C0.774945 17.988 0.0174684 16.0699 0 14.0743C0 10.8 1.88571 7.50857 4.23428 6.56571C4.69714 7.97143 5.41714 9.87429 8.45143 9.85714C5.16 3.29143 10.3371 0 11.2629 0C11.2629 3.06857 13.2171 5.16 14.9829 7.40572L9.97714 16.3886L6.12 12.2743L2.12571 19.4571ZM10.3371 19.2343L6.48 15.12L3.39428 20.64C4.98003 21.8526 6.9181 22.5146 8.91428 22.5257C13.6114 22.5257 17.8286 18.7714 17.8286 14.0743C17.8286 12.0171 17.0914 10.3886 16.0971 8.91429L10.3371 19.2343Z"
        fill="url(#paint1_linear_4515_10212)"
      />
      <path
        d="M5.31428 13.7483L2.12571 19.4569C0.774945 17.9878 0.0174684 16.0696 0 14.074C0 10.7997 1.88571 7.50829 4.23428 6.56543C3.01714 8.58829 3.20571 10.954 5.31428 13.7483ZM6.48 15.1197L3.39428 20.6397L3.61714 20.8111C7.61143 23.6054 10.2514 19.1654 6.48 15.1197Z"
        fill="url(#paint2_linear_4515_10212)"
      />
      <path
        d="M16.0962 8.91429C17.0905 10.3886 17.8276 12.0171 17.8276 14.0743C17.8276 18.7714 13.6105 22.5257 8.91336 22.5257C7.63071 22.5197 6.36353 22.2453 5.19336 21.72C8.41621 23.1257 9.94193 21.7029 10.3362 19.2343L16.0962 8.91429ZM14.9819 7.40572C13.2162 5.16 11.2619 3.06857 11.2619 0C10.3362 0 5.15907 3.29143 8.4505 9.85714C9.37436 11.7372 9.99902 13.7501 10.3019 15.8229L14.9819 7.40572Z"
        fill="url(#paint3_linear_4515_10212)"
      />
      <path
        d="M16.0959 8.91429C17.0902 10.3886 17.8273 12.0171 17.8273 14.0743C17.8273 17.8457 15.1016 21.0171 11.6045 22.1143C14.8273 21.0343 17.0216 16.7486 14.1245 12.4286L16.0959 8.91429ZM13.0102 10.9543L14.9816 7.40572C13.2159 5.16 11.2616 3.06857 11.2616 0C9.92445 1.8 8.70731 5.16 13.0102 10.9543Z"
        fill="url(#paint4_linear_4515_10212)"
      />
      <path
        d="M5.31428 13.7483L2.12571 19.4569C0.774945 17.9878 0.0174684 16.0696 0 14.074C0 10.7997 1.88571 7.50829 4.23428 6.56543C3.01714 8.58829 3.20571 10.954 5.31428 13.7483ZM6.48 15.1197L3.39428 20.6397L3.61714 20.8111C7.61143 23.6054 10.2514 19.1654 6.48 15.1197Z"
        fill="url(#paint5_linear_4515_10212)"
      />
      <path
        d="M16.0962 8.91429C17.0905 10.3886 17.8276 12.0171 17.8276 14.0743C17.8276 18.7714 13.6105 22.5257 8.91336 22.5257C7.63071 22.5197 6.36353 22.2453 5.19336 21.72C8.41621 23.1257 9.94193 21.7029 10.3362 19.2343L16.0962 8.91429ZM14.9819 7.40572C13.2162 5.16 11.2619 3.06857 11.2619 0C10.3362 0 5.15907 3.29143 8.4505 9.85714C9.37436 11.7372 9.99902 13.7501 10.3019 15.8229L14.9819 7.40572Z"
        fill="url(#paint6_linear_4515_10212)"
      />
      <path
        d="M16.0959 8.91429C17.0902 10.3886 17.8273 12.0171 17.8273 14.0743C17.8273 17.8457 15.1016 21.0171 11.6045 22.1143C14.8273 21.0343 17.0216 16.7486 14.1245 12.4286L16.0959 8.91429ZM13.0102 10.9543L14.9816 7.40572C13.2159 5.16 11.2616 3.06857 11.2616 0C9.92445 1.8 8.70731 5.16 13.0102 10.9543Z"
        fill="url(#paint7_linear_4515_10212)"
      />
      <path
        d="M17.8279 6.08588C17.8235 6.43003 17.6848 6.75885 17.4414 7.00222C17.198 7.2456 16.8692 7.38429 16.5251 7.38873C16.1793 7.38441 15.8486 7.24629 15.6025 7.00336C15.3564 6.76043 15.2139 6.43159 15.2051 6.08588C15.2051 5.14302 16.0451 5.14302 15.5822 3.7373C17.4679 4.20016 17.8279 5.38302 17.8279 6.08588Z"
        fill="url(#paint8_linear_4515_10212)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4515_10212"
          x1="11.1754"
          y1="11.2423"
          x2="2.268"
          y2="16.2789"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#FFE187" />
          <stop offset="0.24" stopColor="#FFD986" />
          <stop offset="0.33" stopColor="#FFC384" />
          <stop offset="0.44" stopColor="#FFA081" />
          <stop offset="0.55" stopColor="#FF737D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4515_10212"
          x1="16.6903"
          y1="12.4937"
          x2="6.62228"
          y2="10.7194"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.24" stopColor="#FFE187" />
          <stop offset="0.28" stopColor="#FFE187" stopOpacity="0.95" />
          <stop offset="0.36" stopColor="#FFE187" stopOpacity="0.83" />
          <stop offset="0.46" stopColor="#FFE187" stopOpacity="0.62" />
          <stop offset="0.58" stopColor="#FFE187" stopOpacity="0.34" />
          <stop offset="0.72" stopColor="#FFE187" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4515_10212"
          x1="4.15543"
          y1="6.57057"
          x2="4.15543"
          y2="21.6854"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.14" stopColor="#FFE187" />
          <stop offset="0.35" stopColor="#FFC084" />
          <stop offset="0.78" stopColor="#FF737D" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4515_10212"
          x1="9.97792"
          y1="0.111429"
          x2="11.9185"
          y2="22.296"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.25" stopColor="#FFE187" />
          <stop offset="0.33" stopColor="#FFD286" />
          <stop offset="0.67" stopColor="#FF8E7F" />
          <stop offset="0.83" stopColor="#FF737D" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4515_10212"
          x1="16.8519"
          y1="9.504"
          x2="8.33188"
          y2="11.9469"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFE187" />
          <stop offset="0.13" stopColor="#FFD686" />
          <stop offset="0.29" stopColor="#FFBA83" />
          <stop offset="0.49" stopColor="#FF8B7F" />
          <stop offset="0.59" stopColor="#FF737D" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4515_10212"
          x1="7.42628"
          y1="13.1277"
          x2="0.347999"
          y2="16.5803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE187" />
          <stop offset="0.03" stopColor="#FFE187" stopOpacity="0.92" />
          <stop offset="0.12" stopColor="#FFE187" stopOpacity="0.71" />
          <stop offset="0.21" stopColor="#FFE187" stopOpacity="0.52" />
          <stop offset="0.31" stopColor="#FFE187" stopOpacity="0.36" />
          <stop offset="0.4" stopColor="#FFE187" stopOpacity="0.23" />
          <stop offset="0.5" stopColor="#FFE187" stopOpacity="0.13" />
          <stop offset="0.6" stopColor="#FFE187" stopOpacity="0.06" />
          <stop offset="0.71" stopColor="#FFE187" stopOpacity="0.01" />
          <stop offset="0.83" stopColor="#FFE187" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4515_10212"
          x1="17.2551"
          y1="10.0646"
          x2="3.57165"
          y2="12.4766"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#FFE187" />
          <stop offset="0.15" stopColor="#FFE187" stopOpacity="0.8" />
          <stop offset="0.19" stopColor="#FFE187" stopOpacity="0.62" />
          <stop offset="0.23" stopColor="#FFE187" stopOpacity="0.45" />
          <stop offset="0.27" stopColor="#FFE187" stopOpacity="0.31" />
          <stop offset="0.32" stopColor="#FFE187" stopOpacity="0.2" />
          <stop offset="0.37" stopColor="#FFE187" stopOpacity="0.11" />
          <stop offset="0.42" stopColor="#FFE187" stopOpacity="0.05" />
          <stop offset="0.48" stopColor="#FFE187" stopOpacity="0.01" />
          <stop offset="0.57" stopColor="#FFE187" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4515_10212"
          x1="16.0462"
          y1="20.2971"
          x2="11.3404"
          y2="9.47657"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.41" stopColor="#FF737D" />
          <stop offset="0.46" stopColor="#FF737D" stopOpacity="0.95" />
          <stop offset="0.54" stopColor="#FF737D" stopOpacity="0.83" />
          <stop offset="0.65" stopColor="#FF737D" stopOpacity="0.62" />
          <stop offset="0.79" stopColor="#FF737D" stopOpacity="0.34" />
          <stop offset="0.93" stopColor="#FF737D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4515_10212"
          x1="14.9668"
          y1="4.35102"
          x2="18.2634"
          y2="7.6493"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#FFE187" />
          <stop offset="0.35" stopColor="#FFC084" />
          <stop offset="0.84" stopColor="#FF737D" />
        </linearGradient>
      </defs>
    </Svg>
  );
}

export default NumberFireLogo;
